import { useState, useMemo } from "react";
import ButtonIconH from "./ButtonIconH";
import Dropdown from "./Dropdown";
import CheckBox from "./CheckBox";
import { printCode } from "../devices/godex";
import "../css/Panel.css";
import "../css/Patient.css";
import "../css/PatientSearch.css";
import "../support-extra/css/GodexPrinting.css";
import "../css/GoDexLabelPopup.css";
import { formatValueUnit, goDexPrintFormatTypes } from "../js/utils";

const DEFAULT_DESCRIPTION = "PVP";
const DEFAULT_LABEL_FORMAT = 1; // FORMATO ETIQUETA COLGANTE.

export default function GoDexLabelMultiplePopup({
  store = false,
  directPrinting = false,
  products,
  onClose,
}) {
  const [selectedFormat, setSelectedFormat] = useState({
    id: "type5",
    text: "DESCRIPTIVO (COLGANTE)",
  });
  const [printType, setPrintType] = useState(0);

  const isOfferFormat =
    selectedFormat.id === "type3" || selectedFormat.id === "type6";

  const productsToPrint = useMemo(
    () =>
      isOfferFormat
        ? products.filter((p) => p.pvpOferta && p.pvpOferta !== "")
        : products,
    [products, isOfferFormat],
  );

  const totalStock = useMemo(
    () =>
      productsToPrint.reduce((acc, p) => acc + Math.max(0, p.stock || 0), 0),
    [productsToPrint],
  );

  // console.log("PRODUCTOS A IMPRIMIR: ", products);

  const handleLabel = (description) => {
    return selectedFormat.id === "type1" || selectedFormat.id === "type4"
      ? DEFAULT_DESCRIPTION
      : description;
  };

  const printLabels = async (single = false) => {
    productsToPrint.map(async (e) => {
      await printCode(
        selectedFormat.id,
        e.codigo,
        handleLabel(e.etiqueta),
        e.pvp,
        selectedFormat.id === "type7" || selectedFormat.id === "type8"
          ? e.pvpRecomendado
          : e.pvpOferta,
        single ? 1 : e.stock,
      );
      // console.log(
      // "> IMPRIMIENDO PRODUCTO: ",
      // selectedFormat.id,
      // e.codigo,
      // handleLabel(e.etiqueta),
      // e.pvp,
      // selectedFormat.id === "type7" || selectedFormat.id === "type8"
      // ? e.pvpRecomendado
      // : e.pvpOferta,
      // single ? 1 : e.stock,
      // );
    });
  };

  return (
    <div className="popup-container" style={{ zIndex: 11 }}>
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Impresión de etiquetas
          </span>
          <button className="popup-action-icon close-icon" onClick={onClose}>
            <img src="/images/close-white.svg" loading="lazy" alt="Icon" />
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel" style={{ width: 600 }}>
            <div
              className="data-field data-field-tests"
              style={{ alignItems: "center", gap: 20 }}
            >
              {directPrinting &&
                isOfferFormat &&
                productsToPrint.length === 0 && (
                  <span>
                    El producto seleccionado no tiene PVP Oferta. No es posible
                    imprimir este formato de etiqueta.
                  </span>
                )}
              {!directPrinting && (
                <>
                  <>
                    {printType === 0 && (
                      <span>
                        {isOfferFormat &&
                        productsToPrint.length < products.length
                          ? productsToPrint.length === 0
                            ? `Ninguno de los ${products.length} productos seleccionados tiene PVP Oferta. No es posible realizar la impresión.`
                            : `De los ${products.length} productos seleccionados, ${productsToPrint.length} ${productsToPrint.length === 1 ? "tiene" : "tienen"} PVP Oferta y ${productsToPrint.length === 1 ? "será impreso" : "serán impresos"}.`
                          : productsToPrint.length === 1
                            ? "Se imprimirá una etiqueta para el producto seleccionado."
                            : `Se imprimirá una etiqueta por cada uno de los ${productsToPrint.length} productos seleccionados.`}
                      </span>
                    )}
                  </>
                  <>
                    {printType === 1 && (
                      <span>
                        {isOfferFormat
                          ? productsToPrint.length === 0
                            ? `Ninguno de los ${products.length} productos seleccionados tiene PVP Oferta. No es posible realizar la impresión.`
                            : totalStock === 0
                              ? `${productsToPrint.length === 1 ? "El producto" : `Los ${productsToPrint.length} productos`} con PVP Oferta no ${productsToPrint.length === 1 ? "dispone" : "disponen"} de stock positivo. No es posible realizar la impresión.`
                              : productsToPrint.length < products.length
                                ? `De los ${products.length} productos seleccionados, ${productsToPrint.length} tienen PVP Oferta. Se imprimirán ${formatValueUnit(totalStock)} ${totalStock === 1 ? "etiqueta" : "etiquetas"} según su stock.`
                                : `Se imprimirán etiquetas según el stock de los ${productsToPrint.length} productos seleccionados: un total de ${formatValueUnit(totalStock)} ${totalStock === 1 ? "etiqueta" : "etiquetas"}.`
                          : totalStock === 0
                            ? `${productsToPrint.length === 1 ? "El producto seleccionado no dispone" : "Los productos seleccionados no disponen"} de stock positivo. No es posible realizar la impresión.`
                            : `Se imprimirán etiquetas según el stock ${productsToPrint.length === 1 ? "del producto seleccionado" : `de cada uno de los ${productsToPrint.length} productos seleccionados`}: un total de ${formatValueUnit(totalStock)} ${totalStock === 1 ? "etiqueta" : "etiquetas"}.`}
                      </span>
                    )}
                  </>
                </>
              )}
              <div
                className="opt-table-content grid-2"
                id="goDex-multiple-content-grid"
              >
                <div className="cell cell-start-content combined-cells-2">
                  <div className="data-field" style={{ flex: 1 }}>
                    <span className="label">Formato de impresión</span>
                    <Dropdown
                      optionList={
                        !store
                          ? goDexPrintFormatTypes.filter(
                              (e) =>
                                e.labelFormat === DEFAULT_LABEL_FORMAT &&
                                e.id !== "type3" &&
                                e.id !== "type6",
                            )
                          : goDexPrintFormatTypes.filter(
                              (e) => e.labelFormat === DEFAULT_LABEL_FORMAT,
                            )
                      }
                      size={0}
                      op={selectedFormat.id}
                      onChange={(e) => {
                        setSelectedFormat(e);
                      }}
                    ></Dropdown>
                  </div>
                </div>
                {!directPrinting && (
                  <>
                    <div className="cell cell-start-content">
                      <div
                        className="data-field"
                        onClick={() => {
                          setPrintType(0);
                        }}
                      >
                        <span className="label">Imprimir una etiqueta</span>
                        <CheckBox
                          tabIndex={-1}
                          active={printType === 0}
                          onClick={() => {}}
                        ></CheckBox>
                      </div>
                    </div>
                    <div className="cell cell-start-content">
                      <div
                        className="data-field"
                        onClick={() => {
                          setPrintType(1);
                        }}
                      >
                        <span className="label">Imprimir stock</span>
                        <CheckBox
                          tabIndex={-1}
                          active={printType === 1}
                          onClick={() => {}}
                        ></CheckBox>
                      </div>
                    </div>
                  </>
                )}
                <div
                  className="cell combined-cells-2"
                  style={{ marginTop: 20, gap: 20 }}
                >
                  <ButtonIconH
                    text="Imprimir"
                    small={true}
                    disabled={
                      productsToPrint.length === 0 ||
                      (printType === 1 && totalStock === 0)
                    }
                    onClick={async () => {
                      await printLabels(printType === 0);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
